export const CHARGEBEE = "Chargebee";
export const CHARGEBEE_BASE_URL = process.env.NEXT_PUBLIC_CHARGEBEE_URL;
export const CHARGEBEE_CB_SITE = process.env.NEXT_PUBLIC_CHARGEBEE_CB_SITE;

export const SCRIPTS = {
  [CHARGEBEE]: {
    url: CHARGEBEE_BASE_URL,
    attributes: { "data-cb-site": CHARGEBEE_CB_SITE },
    getInstance: () => window?.Chargebee,
  },
};
